import React, { Component } from 'react';
import {
  Create,
  TextInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  ImageInput,
  ImageField,
  DateInput,
  LongTextInput,
  required,
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import UploadToolbar from 'components/UploadToolbar';
import RichTextInput from 'ra-input-rich-text';
import PictureNote from 'components/PictureNote';

const styles = {
  root: {
    marginTop: '24px',
  },
};

const types = [
  { id: 'normal', name: 'Normal' },
  { id: 'special', name: 'Special' },
  { id: 'birthday', name: 'Birthday' },
];
const themes = [{ id: 'light', name: 'Light' }, { id: 'dark', name: 'Dark' }];

const customValidation = values => {
  const errors = {};
  if (values.started_at > values.expired_at) {
    errors.expired_at = ['Expired at must be greater than Started at'];
  }
  return errors;
};

class CreateForm extends Component {
  state = {
    carBrandID: '',
    type: 'normal',
  };

  handleChangeCarBrand = (e, value) => {
    this.setState({ carBrandID: value });
  };
  handleChangeType = (e, value) => {
    this.setState({ type: value });
  };

  renderContainer() {
    const { classes, ...rest } = this.props;
    const { type, carBrandID } = this.state;
    return (
      <Create title={'New Voucher'} {...rest}>
        <SimpleForm validate={customValidation} toolbar={<UploadToolbar source={['cover_url']} />}>
          <ReferenceInput
            source="car_brand_id"
            reference="brands"
            validate={required()}
            onChange={this.handleChangeCarBrand}
            perPage={-1}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          {carBrandID && (
            <ReferenceInput
              source="car_model_id"
              reference="models"
              filter={{ car_brand_id: carBrandID }}
              perPage={-1}
              emptyValue={0}
              allowEmpty={true}
            >
              <SelectInput optionText="name" />
            </ReferenceInput>
          )}
          <ImageInput source="qcover_url" label="Cover" accept="image/jpeg,image/png" validate={required()}>
            <ImageField source="src" title="title" />
          </ImageInput>
          <PictureNote width="400" height="600" />
          <SelectInput source="type" choices={types} onChange={this.handleChangeType} validate={required()} />
          {type !== 'normal' && <SelectInput source="theme" choices={themes} validate={required()} />}
          {type !== 'normal' && <TextInput source="headline" label={'Headline'} validate={required()} />}
          {type !== 'normal' && <TextInput source="subheadline" label={'Sub headline'} validate={required()} />}
          <TextInput source="title" label={'Title'} validate={required()} />
          <LongTextInput source="description" validate={required()} />
          <RichTextInput source="t_and_c" label={'T&C'} validate={required()} />
          <DateInput source="started_at" label={'Start Date'} validate={required()} />
          <DateInput source="expired_at" label={'End Date'} validate={required()} />
        </SimpleForm>
      </Create>
    );
  }

  render() {
    return this.renderContainer();
  }
}

export default withStyles(styles)(CreateForm);



// WEBPACK FOOTER //
// ./src/containers/Voucher/CreateForm.js